import React from 'react';
import './Spinner.css';

const Spinner = () => (
  <div className="spinner-container">
    <div className="spinner">
      <div className="spinner-inner"></div>
    </div>
  </div>
);

export default Spinner;